module.exports = __webpack_public_path__ + "img/net_down_code.d2e86d98.png";